module.exports = __webpack_public_path__ + "assets/ic_search.d468b5d9.svg";